import styled from 'styled-components';

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));

  grid-gap: 2rem 0;

  width: 100%;
  background: #0f0f0f;

  @media (min-width: 1010px) {
    grid-template-columns: repeat(2, 200px);
    grid-gap: 5.6rem 11.5rem;
  }
`;

export const Info = styled.div``;

export const Label = styled.p`
  font-weight: bold;
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #fff;
`;

export const Text = styled.p`
  font-size: 1.8rem;
  line-height: 2.2rem;
  color: #fff;
`;

export const AlertContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  flex: 1;

  > h1 {
    color: #ffdf22;
  }
`;
